import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { forgotPasswordApi } from '../../lib/api';
import { Toaster, toast } from 'sonner';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_9e7963b6-8d0a-418d-8246-af7a5b4f8387/artifacts/h6dgewwm_image.png';

export default function ForgotPasswordPage() {
  const { t } = useApp();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await forgotPasswordApi({ email });
      setSent(true);
    } catch (err) {
      toast.error(t('forgotPw.error'));
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6 py-24" data-testid="forgot-password-page">
        <div className="w-full max-w-md text-center">
          <img src={LOGO_URL} alt="LUXOR TEK" className="h-12 mx-auto mb-6" />
          <div className="card-dark p-8">
            <CheckCircle className="w-16 h-16 text-[#10B981] mx-auto mb-4" />
            <h2 className="text-xl font-bold mb-2" data-testid="reset-sent-title">{t('forgotPw.checkEmail')}</h2>
            <p className="text-white/60 mb-2">{t('forgotPw.sentMsg')} <span className="text-[#00D4FF]">{email}</span>{t('forgotPw.sentMsg2')}</p>
            <p className="text-white/40 text-sm mb-6">{t('forgotPw.linkExpires')}</p>
            <Link to="/buyer/login" className="btn-primary inline-block" data-testid="back-to-login-link">{t('common.backToLogin')}</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-24" data-testid="forgot-password-page">
      <Toaster position="top-right" theme="dark" />
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <img src={LOGO_URL} alt="LUXOR TEK" className="h-12 mx-auto mb-6" />
          <h1 className="text-2xl font-bold">{t('forgotPw.title')}</h1>
          <p className="text-white/60 mt-2">{t('forgotPw.subtitle')}</p>
        </div>
        <div className="card-dark p-8">
          <form onSubmit={handleSubmit} className="space-y-6" data-testid="forgot-password-form">
            <div>
              <label className="block text-white/60 text-sm mb-2">{t('forgotPw.emailLabel')}</label>
              <div className="relative">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-white/40" />
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 bg-[#050505] border border-white/10 focus:border-[#00D4FF]"
                  placeholder="buyer@company.com"
                  data-testid="forgot-email-input"
                />
              </div>
            </div>
            <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="forgot-submit-btn">
              {loading ? t('forgotPw.sending') : t('forgotPw.sendLink')}
            </button>
          </form>
        </div>
        <div className="mt-8 text-center">
          <Link to="/buyer/login" className="text-white/40 hover:text-white text-sm flex items-center justify-center gap-2">
            <ArrowLeft className="w-4 h-4" /> {t('common.backToLogin')}
          </Link>
        </div>
      </div>
    </div>
  );
}
